.rounded-btn {
  @apply w-12 h-12 flex items-center justify-center;
  @apply bg-[#303030] text-white dark:border-none border rounded-full;
  @apply text-xs;

  &:global(.dark) {
    @apply bg-white text-black;
  }

  &:hover {
    @apply transition;

    &:global(.dark) {
      @apply bg-gray-200;
    }
    @apply bg-neutral-700;

    &.white {
      @apply bg-gray-200;
    }
    &.black {
      @apply bg-neutral-700;
    }
  }

  &.selected {
    box-shadow: 0 0 0 5px #757575;
  }

  &.white {
    @apply bg-white text-black;
  }

  &.black {
    @apply bg-[#303030] text-white;
  }
}

.social-btn {
  @apply block;
  @apply rounded-full;
}
